<template>
	<el-container>
		<el-header class="header">
			 <div class="logo">
				{{sysName}} &nbsp;&nbsp;<i class="fa fa-fw fa-bars" @click="toggleCollapse"></i>
			</div> 
			<div class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner">{{sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</el-header>
		<el-container>
		<el-aside :width="isCollapse?'64px':'200px'">
			<el-menu :collapse="isCollapse"
				default-active="1-4-1"
				class="el-menu-vertical-demo"
				>
				<el-submenu :index="headmenu.MePath + ''" v-for="headmenu in headMenuItems" :key="headmenu.MePath">
					<!-- 一级菜单的模版区域 -->
					<template slot="title">
						<!-- 图标 -->
						<i :class="headmenu.className"></i>
						<!-- 文本 -->
						<span>{{headmenu.Description}}</span>
					</template>
					<!-- 二级菜单 -->
					<el-menu-item :index="'/'+submenu.MePath"  v-for="submenu in subMenuItems" 
						v-if="submenu.ParentPath == headmenu.MePath"
						:key="submenu.MePath" 
						@click="handleSelectLeftMenu(submenu)" >
						<template slot="title" >
							<!-- 图标 -->
							<i :class="submenu.className"></i>
							<!-- 文本 -->
							<span>{{ submenu.Description }}</span>
						</template>
					</el-menu-item>
				</el-submenu>
			</el-menu>
		</el-aside>
		<el-main>
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</el-main>
		</el-container>
	</el-container>
</template>

<script>
    import HomeJs from "./Home.js";
    export default HomeJs;
</script>

<style scoped lang="scss">
	@import '~scss_vars';
	.header {
		background-color: #438eb9;
		height: 50px !important;

		.logo {
			color: #fff;
			font-size: 24px;
			text-shadow: none;
			width: 300px;
			float: left;
			position: relative; /*脱离文档流*/
			top: 15%;
			font-weight: 200;
		}
		.userinfo {
			text-align: right;
			padding-right: 35px;
			float: right;
			.userinfo-inner{
				color:#fff;
				font-size: 18px;
				font-weight: 200;
			}
			position: relative; /*脱离文档流*/
			top: 35%;
		}
	}

	.el-aside {
		background-color: #f2f2f2;
		    color: #fff;	
		.el-menu {
			border:1px solid #ccc; 
			height: 99%;
			
			background-color: #f2f2f2;
			
		}
		
	}

	
	// .container {
	// 	position: absolute;
	// 	top: 0px;
	// 	bottom: 0px;
	// 	width: 100%;
	// 	.MenuItem {
	// 		height: 17px;
	// 		font-size: 12px;
	// 		font-weight: bold;
	// 		font-style: normal;
	// 		font-stretch: normal;
	// 		letter-spacing: normal;
	// 		text-align: left;
	// 		color: #4a4a4a;
	// 		}	
		
	// 		.logo {
	// 			//width:230px;
	// 			height:40px;
	// 			font-size: 22px;
	// 			font-weight: 200;
	// 			padding-left:20px;
	// 			padding-right:20px;
	// 			border-right-width: 0px;
	// 			border-right-style: solid;
	// 			text-transform: uppercase;
	// 			.txt {
	// 				color:#e3ebf3;
	// 			}
	// 		}
	// 		.logo-width{
	// 			width:230px;
	// 		}
	// 		.logo-collapse-width{
	// 			width:60px
	// 		}
	// 		.tools{
	// 			padding: 0px 23px;
	// 			width:14px;
	// 			height: 60px;
	// 			line-height: 60px;
	// 			cursor: pointer;
	// 		}
	// 	}
	// 	.leftmenu{
	// 		height: 100%;
	// 		//background: #c0c0c0;
	// 	}
		
	// 	.main {
	// 		display: flex;
	// 		//background: #c0c0c0;
	// 		position: absolute;
	// 		top: 60px;
	// 		bottom: 0px;
	// 		overflow: hidden;
			
	// 		aside {
	// 			flex:0 0 120px;
	// 			width: 120px;
	// 			// position: absolute;
	// 			// top: 0px;
	// 			// bottom: 0px;
	// 			.el-menu{
	// 				height: 100%;
	// 			}
	// 			.collapsed{
	// 				width:60px;
	// 				.item{
	// 					position: relative;
	// 				}
	// 				.submenu{
	// 					position:absolute;
	// 					top:0px;
	// 					left:60px;
	// 					z-index:99999;
	// 					height:auto;
	// 					display:none;
	// 				}

	// 			}
	// 		}
	// 		.menu-collapsed{
	// 			flex:0 0 60px;
	// 			width: 60px;
	// 		}
	// 		.menu-expanded{
	// 			flex:0 0 230px;
	// 			width: 230px;
	// 		}
	// 		.content-container {
	// 			// background: #f1f2f7;
	// 			flex:1;
	// 			// position: absolute;
	// 			// right: 0px;
	// 			// top: 0px;
	// 			// bottom: 0px;
	// 			// left: 230px;
	// 			overflow-y: scroll;
	// 			padding: 10px;
	// 			.breadcrumb-container {
	// 				//margin-bottom: 15px;
	// 				.title {
	// 					width: 200px;
	// 					float: left;
	// 					color: #475669;
	// 				}
	// 				.breadcrumb-inner {
	// 					float: right;
	// 				}
	// 			}
	// 			.content-wrapper {
	// 				background-color: #fff;
	// 				box-sizing: border-box;
	// 			}
	// 		}
	// 	}
</style>


// WEBPACK FOOTER //
// src/components/Home/Home.vue